import React, { useContext, useEffect } from 'react';
import { EditorContext } from './EditorCommon/EditorContext';

export function ChainCss(props:{
	
}) {

    const ec = useContext(EditorContext);
    const cssUrl = ec.cabinetService.chainInfo.cssUrl;
    useEffect(() => {
        if (!cssUrl) {
            return;
        }
        const elem = window.document.createElement("link");
        elem.rel = "stylesheet";
        elem.href = cssUrl;
        elem.className = "chain-css";
        window.document.head.appendChild(elem);

        return function cleanup() {
            window.document.head.removeChild(elem);
        }
    })
    return <></>;
}
